import { render, staticRenderFns } from "./ReportHistoryWidget.vue?vue&type=template&id=6a7b3ba4&"
import script from "./ReportHistoryWidget.vue?vue&type=script&lang=js&"
export * from "./ReportHistoryWidget.vue?vue&type=script&lang=js&"
import style0 from "./ReportHistoryWidget.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\escal\\Projects\\Betterway.Vms\\Betterway.VMS.web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6a7b3ba4')) {
      api.createRecord('6a7b3ba4', component.options)
    } else {
      api.reload('6a7b3ba4', component.options)
    }
    module.hot.accept("./ReportHistoryWidget.vue?vue&type=template&id=6a7b3ba4&", function () {
      api.rerender('6a7b3ba4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Widgets/ReportHistoryWidget.vue"
export default component.exports